import { Scene } from 'phaser';
import { BotaoArcade } from '../components/BotaoArcade';
import { desenharPaginaLima } from '../components/cenario';
import { ModalArcade } from '../components/ModalArcade';
import { PainelIndicadores } from '../components/PainelIndicadores';
import { SCENES, TEX } from '../config/constants';
import { ARCADE_HEX, ARCADE_TEXT } from '../config/theme';
import { indicadoresDaJornada, partirPerfil, ProgressoPlayer1, resolverFaixa, somar } from '../services/player1';
import { Sessao } from '../services/Sessao';
import { t } from '../services/textos';

/**
 * Player 1 — perfil e finalização (Figma, quadros 15, 16 e 33).
 * RN-P1-02 / RN-P1-08: mostra o perfil e os quatro indicadores; não há
 * pontos de ranking, posição nem comparação com outros participantes.
 */
export class Player1ResultadoScene extends Scene {
    constructor () {
        super(SCENES.PLAYER1_RESULTADO);
    }

    async create () {
        if (!Sessao.ativa) {
            this.scene.start(SCENES.LOGIN);
            return;
        }
        this.modal = null;
        const fonte = this.registry.get('fonte');
        const progresso = new ProgressoPlayer1(Sessao.atual.participanteId);

        desenharPaginaLima(this, { titulo: t('p1.titulo'), rotuloJogador: Sessao.rotulo, rotuloY: 128, espacamento: 0 });
        this.add.image(64, 48, TEX.BTN_INSIGHTS_REDONDO).setOrigin(0)
            .setInteractive({ useHandCursor: true })
            .on('pointerup', () => !this.modal && this.scene.start(SCENES.AGUARDE, {}));

        let jornada;
        try {
            jornada = await fonte.obterCatalogoPlayer1();
        } catch (falha) {
            console.error('[Player1] catálogo indisponível para montar o perfil.', falha);
            if (this.scene.isActive()) {
                this.add.text(640, 400, t('p1.erro_perfil'), ARCADE_TEXT.aviso).setOrigin(0.5);
                new BotaoArcade(this, 640, 500, { rotulo: t('geral.voltar'), aoClicar: () => this.scene.start(SCENES.AGUARDE, {}) });
            }
            return;
        }
        if (!this.scene.isActive()) return;

        // RN-P1-07 / RI-P1-08: valores finais dos quatro indicadores e o perfil da faixa.
        const indicadores = indicadoresDaJornada(jornada.capitulos, progresso.estado.decisoes);
        const faixa = resolverFaixa(jornada.faixas, somar(indicadores));
        const perfil = partirPerfil(faixa?.texto);

        this.add.text(64, 198, t('p1.voce_e'), { ...ARCADE_TEXT.introducao, fontSize: '24px' }).setOrigin(0, 0.5);
        this.add.text(64, 238, (faixa?.titulo ?? '').toUpperCase(), ARCADE_TEXT.manchete).setOrigin(0, 0.5);
        this.add.rectangle(64, 275, 631, 1, ARCADE_HEX.TINTA).setOrigin(0, 0.5);
        const descricao = this.add.text(64, 299, perfil.descricao, {
            ...ARCADE_TEXT.introducao, lineSpacing: 3, wordWrap: { width: 640 }
        });
        for (const tamanho of [28, 26, 24, 22]) {
            descricao.setFontSize(tamanho);
            if (descricao.height <= 330) break;
        }

        new PainelIndicadores(this, 852, 219, { tamanho: 'amplo', valores: true }).definir(indicadores);

        // RI-P1-09: Continuar abre o pop-up de finalização.
        new BotaoArcade(this, 640, 701, { rotulo: t('geral.continuar'), aoClicar: () => this.abrirFinalizacao(jornada, perfil) });

        // Sync único da jornada; se falhar fica pendente e volta a ser tentado
        // aqui, com a mesma chave, na próxima vez que a tela abrir.
        if (!progresso.estado.enviado) {
            try {
                await fonte.enviarResultadoPlayer1(progresso.envio());
                progresso.marcarEnviado();
            } catch (falha) {
                console.error('[Player1] jornada não enviada; fica pendente.', falha);
            }
        }
    }

    abrirFinalizacao (jornada, perfil) {
        if (this.modal) return;
        this.modal = new ModalArcade(this, {
            titulo: jornada.titulo,
            largura: 800, centroY: 392, botaoY: 628,
            blocos: [
                ...(perfil.saudacao ? [{ texto: perfil.saudacao.replace(/([!?])\1+/g, '$1'), peso: '700', maiusculas: true }] : []),
                ...perfil.mensagem.map((texto) => ({ texto }))
            ],
            // RI-P1-10: quem devolve o participante ao Aguarde é o facilitador (FINALIZAR a experiência, via
            // `aoEstacao`); o botão só existe no modo dev, que não tem facilitador.
            ...(this.registry.get('fonte')?.modo === 'dev' ? {
                botao: {
                    rotulo: t('geral.concluir'), largura: 368,
                    aoClicar: () => this.scene.start(SCENES.AGUARDE, { concluida: 'player1' })
                }
            } : {}),
            voltar: { rotulo: t('geral.voltar_pontuacao') },
            aoFechar: () => { this.modal = null; }
        });
    }
}
